import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { get, post } from '@core/interceptors/fetch-client';
import { BehaviorSubject } from 'rxjs';
import {
  drowdownValues,
  groupMembercharts,
  keygraphRequest,
} from '@interface/keygraph';
import { ApiUtils } from '../Utils/apiUtils';

@Injectable({
  providedIn: 'root',
})
export class KeyGraphService {
  private keyGraphSubject = new BehaviorSubject<groupMembercharts[]>([]);
  readonly keyGraph$ = this.keyGraphSubject.asObservable();
  private keyGraphDropDownDataSubject = new BehaviorSubject<drowdownValues[]>(
    [],
  );
  readonly keyGraphDropDownDataSubject$ =
    this.keyGraphDropDownDataSubject.asObservable();

  async getKeyGraphData(data: keygraphRequest) {
    let response = null;
    try {
      await ApiUtils.handleApiResponse1(
        post<any>(environment.keyGraphData, data),
        (data, statusCode) => {
          response = { data, statusCode };
        },
        'Failed to fetch Participation Data',
      );
    } catch (error: any) {
      console.log(error);
      response = { data: error, statusCode: error.status || error.statusCode };
    }
    return response;
  }

  async getKeyGraphDropdownData(data: any) {
    let response = null;
    const url = `${environment.keyGraphDropdown}?GroupCompositeId=${data.SelectedPeriod}`;
    try {
      await ApiUtils.handleApiResponse1(
        get<any>(url),
        (data, statusCode) => {
          response = { data, statusCode };
        },
        'Failed to fetch Participation Data',
      );
    } catch (error: any) {
      console.log(error);
      response = { data: error, statusCode: error.status || error.statusCode };
    }
    return response;
  }

  protected updateDropDownData<T>(
    subject: BehaviorSubject<T[]>,
    data: T[],
  ): void {
    subject.next(data);
  }
}
